// This component is used to notifiy the user by important info.
import React, { ReactNode } from 'react';
import { Modal } from '@mui/material';

interface INotificationModalProps{
  children: JSX.Element | ReactNode;
  closeModal: boolean;
}

const NotificationModal: React.FC<INotificationModalProps> = (props: INotificationModalProps) => {
  const { children, closeModal } = props;

  return (
    <Modal
      open={closeModal}
      sx={{
        border: 'none',
        transition: 'opacity 1s ease-in-out',
        WebkitTransition: 'opacity 1s ease-in-out',
        '& .MuiBackdrop-root': {
          transition: 'opacity 0.5s ease-in-out',
          WebkitTransition: 'opacity 0.5s ease-in-out',
        },
      }}
    >  
      <React.Fragment>
        {children}
      </React.Fragment>
    </Modal>
  );
}

export default NotificationModal;